import React from "react";
import { View, Text, TouchableOpacity } from "react-native";
import PatientProfileImage from "components/Partials/PatientProfileImage.js";

const PatientList = ({ patients, onCardPress }) => {
  const _theme = window.main.theme;

  if (!patients?.length) { // If no pets found
    return (
      <View style={{width:"100%",paddingVertical:12}}>
        <Text style={{color:"#555",fontSize:15}}>
          No pets found.
        </Text>
      </View>
    );
  }

  return (
    <View style={{width:"100%"}}>
      {patients.map((patient) => {
        const onPressPatientCard = ()=>{onCardPress(patient);};
        return (
          <TouchableOpacity key={patient.patient_id} onPress={onPressPatientCard} style={{alignItems:"center",backgroundColor:"#ffffff",borderRadius:_theme.borderRadius,justifyContent:"center",marginBottom:16,minHeight:128,paddingHorizontal:12,paddingVertical:12,width:"100%",...window.main.theme.boxShadowStyle}}>
          <PatientProfileImage profile_image_id={patient.profile_image_id} style={{width:72,height:72,marginRight:0}} />
            <Text style={{color:"#222",fontWeight:"bold",fontSize:21,textAlign:"center"}}>
              {patient.name}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

export default PatientList;
